import {OrganisationDTO} from "../../../../DTO/Organisation/OrganisationDTO";

export class KeycloakMatchingDTO {
    authorizationUrl: string;
    tokenUrl: string;
    logoutUrl: string;
    userInfoUrl: string;
    issuer: string;
    jwksUrl: string;
    clientId: string;
    clientSecret: string;
    domain: string
    subDomain: string
    displayName: string
    organisationDTO: OrganisationDTO;

    constructor(data?: Partial<KeycloakMatchingDTO>) {
        if (data) {
            this.bindData(data);
        }
    }

    bindData(data: Partial<KeycloakMatchingDTO>): void {
        if (data) {
            this.authorizationUrl = data.authorizationUrl || '';
            this.tokenUrl = data.tokenUrl || '';
            this.logoutUrl = data.logoutUrl || '';
            this.userInfoUrl = data.userInfoUrl || '';
            this.issuer = data.issuer || '';
            this.jwksUrl = data.jwksUrl || '';
            this.clientId = data.clientId || '';
            this.clientSecret = data.clientSecret || '';
            this.domain = data.domain;
            this.subDomain = data.subDomain;
            this.displayName = data.displayName;
            if (data.organisationDTO) {
                this.organisationDTO = new OrganisationDTO();
                this.organisationDTO.bindData(data.organisationDTO);
            }
        }
    }
}
